module.exports = __webpack_public_path__ + "assets/img/finish.bb3e5c39.png";